import React from "react";

const WhatIs = () => {
  return (
    <div className="pccHeadContentContainer">
      <h2>
        {" "}
        What is Kuwait <span>PCC</span> Verification?{" "}
      </h2>
      <p>
        Kuwait PCC verification involves obtaining a Police Clearance
        Certificate from the applicant's home country (India, in this case) and
        getting it attested to confirm its authenticity for use in Kuwait. The
        process ensures that the document meets Kuwaiti legal standards and is
        accepted by Kuwaiti authorities.
      </p>
    </div>
  );
};

export default WhatIs;
